import { Component, Injector, Input, OnDestroy, OnInit, WritableSignal, computed, signal } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FormControl, FormGroupDirective, FormsModule, NgForm, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Subject, Subscription, catchError } from 'rxjs';
import { MediaMatcher } from '@angular/cdk/layout';
import { Router, RouterModule } from '@angular/router';
import { EventInteractionService } from '@mare-common/ngx-mare-common';
import { MareLoaderModule, MareLoaderService } from '@mare-common/ngx-mare-loader';
import { TokenService } from '@mare-common/web-solveup-library';
import { CompanyService } from 'src/app/services/company.service';
import { PlatformApiWpService } from 'src/app/services/platform-apiwp.service';
import { ReportService } from 'src/app/services/report.service';
import { CommonConfig } from 'src/app/shared/common-config/common-config';
import { environment } from 'src/environments/environment';
import { ErrorStateMatcher } from '@angular/material/core';
import { DownloadAnimationDirective } from 'src/app/shared/directives/download-animation.directive';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
@Component({
  selector: 'app-tool-benchmark',
  standalone: true,
  imports: [CommonModule,
    TranslateModule,
    MatTooltipModule,
    MatTableModule,
    MatCardModule,
    MatDividerModule,
    MatSnackBarModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    NgOptimizedImage,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    RouterModule,
    SharedModule,
    MareLoaderModule,
    DownloadAnimationDirective,
  ],
  templateUrl: './tool-benchmark.component.html',
  styleUrls: ['./tool-benchmark.component.scss']
})
export class ToolBenchmarkComponent implements OnInit, OnDestroy {

  @Input() company: any;
  mobileQuery: MediaQueryList
  reportCount$ = signal<number>(0);
  reportLiteCount$ = signal<number>(0);
  hasActivatedReportLite$ = computed(() => {
    return (this.company.delfi_report_max_light_requests && Number(this.company.delfi_report_max_light_requests) > 0) ? true : false
  });
  
  hasActivatedReport$ = computed(() => {
    return (this.company.delfi_report_max_requests && Number(this.company.delfi_report_max_requests) > 0) ? true : false
  });

  isInitComponent$ = signal<boolean>(false);

  reportCountLimit = 0;
  reportLiteCountLimit = 3;

  // newVatNumber: any;

  benchmarkVatNumber = new FormControl('', [Validators.required, Validators.pattern('[0-9]{11}'), Validators.minLength(11), Validators.maxLength(11)]);
  
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  // = new MatTableDataSource<any>([])
  dataSource$ = computed(() => {
    return this.dataSource
  });
  displayedColumns: string[] = ['idx', 'businessName', 'vatNumber','requestDate', 'action'];
  maxExpireRequestTime = 3600000; //1000 * 60 * 60 ;
  maxElaborationTimeInHours: number = this.commonConfig.getFromConfig('maxElaborationTimeInHours', 1);
  
  benchmarkLiteVatNumber = new FormControl('', [Validators.required, Validators.pattern('[0-9]{11}'), Validators.minLength(11), Validators.maxLength(11)]);
  dataLiteSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  dataLiteSource$ = computed(() => {
    return this.dataLiteSource
  });
  
  unsubscribe$: Subject<any> = new Subject();
  eventInteractionSubscription: Subscription;
  loader: MareLoaderService;

  downloadingReportvatNumber$: WritableSignal<string[]> = signal([]);

  matcher = new MyErrorStateMatcher();

  constructor(private eventInteractionService: EventInteractionService,
    private platformApiWpService: PlatformApiWpService,
    private reportService: ReportService,
    private router: Router,
    private commonConfig: CommonConfig,
    private media: MediaMatcher,
    private _snackBar: MatSnackBar,
    private injector: Injector,
    private loaderService: MareLoaderService,) {
    
      this.loader = loaderService;
      this.mobileQuery = media.matchMedia('(min-width: ' + commonConfig.getMobileBreakpoint() + 'px)');
      this.eventInteractionSubscription = this.eventInteractionService.getObservable().subscribe((data) => {
        switch (data.event) {
          case 'report_check':
          case 'check_completed':
             console.log('is completed...')
            this.updateRequested();
            break;
          default:
            break;
        }
        
      })

  }
  ngOnInit(): void {
    this.isInitComponent$.set(false);
    if (this.company) {
      console.log('company selfcaring', this.company);
      if(this.company.delfi_report_max_requests) {
        this.reportCountLimit = Number(this.company.delfi_report_max_requests)
      }
    }
    this.updateRequested().finally(() => {
      this.isInitComponent$.set(true);
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.unsubscribe();

    if(this.eventInteractionSubscription)
      this.eventInteractionSubscription.unsubscribe();
  }

  updateRequested(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.reportService.getRequested().catch(
        (err) => {
          reject(err)
        }
      ).then((sub: any) => {
        sub.pipe(
          catchError((err: any) => {
            reject(err);
            return err;
          })
      ).subscribe((response: any) => {
        console.log('updateRequested__________',response);
        let data = [];
        const payload = response.payload;
        let makeCheck = false;
        for (const key in payload) {
          if (Object.prototype.hasOwnProperty.call(payload, key)) {
            const element = payload[key];
            let _status = this.checkElementStatus(element);
            console.log('request_status for ' + element.businessName, _status);
            let requestedOn = new Date(Number(element.requestTimestamp) * 1000);
            data.push({
              id: key,
              businessName: element.businessName,
              vatNumber: element.piva,
              requestDate: requestedOn,
              status: _status,
              action: 'action'
            })
            if(element.status == 'started')
              makeCheck = true;
          }
        }
        this.reportCount$.set(data.filter((val) => val.status != 'error').length);
        this.dataSource.data = data;
        if(makeCheck)
          this.reportService.makeCheckAllWithInterval();
        // this.table.renderRows();
        resolve(response)
      });
    })
    })
    
  }

  managePaste(event: any, formControl:FormControl) {
    event.preventDefault();
    const text = event.clipboardData.getData('text/plain');
    // extract numbers from text
    //remobe anityng but numbers from text
    const numbers = text.replace(/[^0-9]/g, '').split('');
    let newVatNumber = numbers.join('');
    formControl.setValue(newVatNumber);
  }
  checkElementStatus(element: any) {
    let status;
    const maxElaborationTime = this.maxElaborationTimeInHours ? this.maxElaborationTimeInHours : 1;
   
    switch (element.status) {
      case 'started':
      case 'requested':
        status = element.status;
        if ((new Date().getTime() - (3600000 * maxElaborationTime) > element.requestTimestamp*1000))
         {
          status = 'expired';
        }
        break;
      case 'error':
        switch(element.error.code) {
          case 500:
            status = 'unavailable';
            break;
          default:
            status = 'error';
            break;
        }
        break;
      default:
        status = element.status;
        break;
    }
    return status;
  }


  getTranslatedStatus(status: string): string {
    switch(status) {
      case 'pending':
        return 'in attesa';
      case 'processing':
        return 'in elaborazione';
      case 'completed':
        return 'completato';
      case 'cancelled':
        return 'cancellato';
    }
    return '';
  }

  getReport(piva: any) {
    this.downloadingReportvatNumber$.update(values => {
     return [... values, piva]
   })
    this.reportService.downloadReport(piva).finally(
      () => {
        // this.loader.hideLoader();
        this.downloadingReportvatNumber$.update(values => {
          return values.filter((val) => val != piva)
        })
      }
    );
  }
  isDownloadingReport(piva: any) {
    return this.downloadingReportvatNumber$().includes(piva);
  }
  getNewReport(piva: any) {
    this.loader.showLoader();
    this.reportService.getReport(piva).catch(
      (err) => {
        this.loader.hideLoader();
      }
    ).then((response: any) => {
      this.updateRequested().finally(()=>{
        this.loader.hideLoader();
      });

    });
  }

  getMoreReport() {
      let basePath = environment.routingBasePath;
      this.router.navigate([basePath + '/digital-report'], { queryParams: { isPage: true } });
    }
  addCompanyReport(isLite: boolean = false) {
    
    if (!isLite && this.reportCount$() >= this.reportCountLimit) {
      return;
    }
    else if (isLite && this.reportLiteCount$() >= this.reportLiteCountLimit) {
      return;
    }
    let pivaToAdd = isLite ? this.benchmarkLiteVatNumber : this.benchmarkVatNumber;
    this.loader.showLoader();
    let alreadyRequested = this.checkIfAlreadyAdded(pivaToAdd.value, isLite);
    if (pivaToAdd.value && !alreadyRequested) {
      this.reportService.getReport(pivaToAdd.value, isLite).catch((err) => { 
        this.loader.hideLoader();
      }).then((response: any) => {
        // this.newVatNumber = null;
        pivaToAdd.setValue(null);
        this.updateRequested().finally(()=>{
          this.loader.hideLoader();
        });
      });
    } else {
      this.loader.hideLoader();
      this.openSnackBar('Hai gia richiesto questo Benchmark', 'Ok ');
    }

  }

  

  checkIfAlreadyAdded(vatNumber: any, isLite: boolean = false) { 
    /** TODO
     * qui andrebbe fatto un controllo per vedere se la piva è elegibile per una nuova richiesta essendo passato tanto tempo o la piva ha avuto un aggiornamento dei dati finanziari
     * */
    if (isLite) {
      return  this.dataLiteSource.data.find((val: any) => val.vatNumber == vatNumber);
    } else {
      return this.dataSource.data.find((val: any) => val.vatNumber == vatNumber);
    }
    // let alreadyAdded = this.dataSource.data.find((val: any) => val.vatNumber == vatNumber);

    // return alreadyAdded ? true : false

  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      verticalPosition: 'bottom',
      panelClass: ['bg-sky', 'bg-text-dark']
    });
  }




}
